<template lang="html">
  <div class="report-group" :class="'group-'+group">
    <div class="group-title">
      <h3 class="text-center title">{{ reportData[group].title }}</h3>
      <div class="text-center score">{{ percent }}%</div>
    </div>

    <div class="responses">
      <div class="row justify-content-center responses-grid">
        <template v-for="(c,i) in content">
          <report-q :qdata="c" :group="group" :key="'q'+c.id" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import GroupQ from '@/views/Results/GroupQ'

export default {
  props: [ 'group' ],
  data() {
    return {
      form: this.$store.state.formData,
      reportData: this.$store.state.reporting,
      content: this.$store.state.content,
      docDefinition: this.$store.state.docDefinition,
    }
  },
  components: {
    'report-q': GroupQ,
  },
  computed: {
    totScore() {
      let scores = [];
      let con = this.content;
      for(let v in con){
        let type = con[v].form.type;
        let opt = con[v].form.options;
        let group = con[v].form.group;
        if(group === this.group){
          if(type === 'checkbox' || type === 'checkbox2'){
            opt.forEach((x)=>{
              let score = x.score ? x.score : 0;
              scores.push(score);
            });
          } else {
            let groupScore = [];
            opt.forEach((x)=>{
              let score = x.score ? x.score : 0;
              groupScore.push(score);
            });
            scores.push(Math.max.apply(null,groupScore));
          }
        }
      }
      return scores.length ? scores.reduce((a,v)=>a + v) : 0;
    },
    score() {
      let scores = [];
      let form = this.form;
      for(let v in form){
        let group = form[v].group;
        if(group === this.group){
            let score = form[v].score ? form[v].score : 0
            scores.push(score);
        }
      }
      return scores.length ? scores.reduce((a,v)=>a + v) : 0;
    },
    percent() {
      return Math.round((this.score / this.totScore) * 100);
    }
  },
  created() {
    const title = {
      text: this.reportData[this.group].title.toUpperCase(),
      headlineLevel: 1,
      style: 'header'
    }

    const score = {
      text: this.percent + '%',
      style: 'score'
    }

    this.docDefinition.content.push( title, score );
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars';
@import '../../assets/scss/mixins';

.report-group {

  &:not(:last-child) {
    margin-bottom: gu(3);
    
    @media only screen and (min-width: 40rem) {
      margin-bottom: gu(7);
    }
  }
}

.group-title {
  padding-bottom: gu(1);
  border-bottom: rem-calc(2) solid $colGradL;
  margin-bottom: gu(2);
}

.title {
  text-transform: uppercase;
  color: $colGradL;
  font-weight: $fwBold;
  line-height: 1;
  margin-bottom: gu(0.5);
  font-size: rem-calc(40);

  @media only screen and (min-width: 40rem) {
    font-size: rem-calc(50);
  }

  @media only screen and (min-width: 64rem) {
    font-size: rem-calc(60);
  }
}

.score {
  font-weight: $fwBold;
  font-size: rem-calc(30);
  color: $colGradL;
  line-height: 1;
}
</style>
